import React from 'react';
import { IconButton32 } from '../../../components/buttons/index.js';
import { CastIcon } from '../../../components/icons/index.js';
import { copyToClipboard } from './copyToClipboard.js';
export function RemoteButton({ devServerOn, rendererUrl, pushNotification, }) {
    if (!devServerOn || !rendererUrl) {
        return null;
    }
    return (React.createElement(IconButton32, { icon: React.createElement(CastIcon, null), title: "Copy remote renderer URL", onClick: copyRendererUrlToClipboard }));
    async function copyRendererUrlToClipboard() {
        const url = await fetchRemoteRendererUrl();
        if (!url) {
            pushNotification({
                id: 'renderer-url-copy',
                type: 'error',
                title: `Failed to fetch remote renderer URL`,
                info: 'Make sure the Cosmos server is running.',
            });
        }
        else {
            try {
                await copyToClipboard(url);
                pushNotification({
                    id: 'renderer-url-copy',
                    type: 'success',
                    title: `Renderer URL copied to clipboard`,
                    info: 'Paste the renderer URL in the address bar of another browser.',
                });
            }
            catch {
                pushNotification({
                    id: 'renderer-url-copy',
                    type: 'error',
                    title: `Failed to copy renderer URL to clipboard`,
                    info: 'Make sure your browser supports clipboard operations.',
                });
            }
        }
    }
}
async function fetchRemoteRendererUrl() {
    try {
        const res = await fetch(`/_cosmos/remote-renderer-url`);
        const body = (await res.json());
        return body.url;
    }
    catch {
        return null;
    }
}
